import { TableHeadersConfig } from '../../utils/utils';

export const registerActivitiesTableConfig: TableHeadersConfig[] = [
  {
    title: '#',
  },
  {
    title: 'Opening date',
    sortingKey: 'openDate',
  },
  {
    title: 'Closing date',
    sortingKey: 'closeDate',
  },
  {
    title: 'Last transaction date',
    sortingKey: 'lastCardTransactionDate',
  },
  {
    title: 'POS',
    sortingKey: 'pos.name',
  },
  {
    title: 'Total',
    sortingKey: 'status',
  },
  {
    title: 'Total Reversed',
  },
  {
    title: 'Total Recharges',
  },
  {
    title: 'Total Discharges',
  },
  {
    title: 'Difference Recharges-Discharges',
  },
  {
    title: 'Action',
  },
];



// WEBPACK FOOTER //
// ./src/pages/register-activities/registerActivitiesTableConfig.ts